import axios from "axios";

//export const getMemberMappedgroups = (id) => axios.get(`api/members/${id}/mapped-groups`);

export const editMember = (id, baseinfo) => axios.put(`/api/members/${id}`, baseinfo);

//get the Notification type user save [0]
export const getMemberNotification = () => axios.get(`api/members/memberNotification`);

export const postMemberNotification = (notiinfo) => axios.post(`api/members/memberNotification`, notiinfo);

//get the Notification type list [1]
export const getNotificationType = () => axios.get(`api/notification-type`);

//get the Notification channel list [2]
export const getNotificationFromList = () => axios.get(`/api/notification-profiles/basic-list`);

//get Prof. user data
export const getProfUserData = () => axios.get(`/api/member-registration/certified-user`);

//get Prof. user data
export const getProfUserDataByMemberId = (memberId) => axios.get(`/api/member-registration/certified-user-by-id?memberID=${memberId}`);

export const editLanguage = (lang) =>axios.put(`/api/user/lang/${lang}`);